document.querySelectorAll('.hacklabr-posts-slider-block').forEach((container) => {
    const params = JSON.parse(container.querySelector('script').innerHTML);
    const wrapper = container.querySelector('.swiper');
    const swiper = hl_createSwiper(wrapper, {
        ...params,
    });

    const prevBtn = container.querySelector('.swiper-button-prev');
    const nextBtn = container.querySelector('.swiper-button-next');

    [prevBtn, nextBtn].forEach((btn, i) => {
        if (btn && !btn.querySelector('.screen-reader-text')) {
            const srText = document.createElement('span');
            srText.className = 'screen-reader-text';
            srText.textContent = i === 0 ? 'Post anterior' : 'Próximo post';
            btn.insertBefore(srText, btn.firstChild);
        }
    });

    wrapper.setAttribute('role', 'region');
    wrapper.setAttribute('aria-label', 'Carrossel de posts');

    const slides = wrapper.querySelectorAll('.swiper-slide');
    slides.forEach((slide, index) => {
        slide.setAttribute('role', 'group');
        slide.setAttribute('aria-label', `Post ${index + 1} de ${slides.length}`);
    });
});
